import type { Ref, ComponentPublicInstance } from "vue";
import { ref } from "vue";
import { R3VisualComponentBase } from "./R3VisualComponenteBase.classes";
import type { DefaultToText, ElementOf } from "@r3backend/src/utils/types";

export class R3InputBase<T = unknown> extends R3VisualComponentBase {
	protected _inputValue!: Ref<T>;

	constructor(initialValue: T) {
		super();
		this._inputValue = ref(initialValue) as Ref<T>;
	}

	public inputValueRef() {
		return this._inputValue;
	}

	/*constructor() {
		//super();
		// watch(this._inputValue, (v) => {
		// 	console.log("Watch acionado: ", v)

		// })
	}*/

	public get inputValue(): T {
		if (!this._inputValue) {
			console.warn("⚠️ _inputValue não inicializado em inputValue getter");
			return null as unknown as T;
		}
		return this._inputValue.value;
	}

	public set inputValue(value: T) {
		this._inputValue.value = value;

		if (this.debounceTime > 0) {
			if (this.setTimeoutID) {
				clearTimeout(this.setTimeoutID);
			}

			this.setTimeoutID = setTimeout(() => {
				if (this._onDebounce) {
					this._onDebounce();
				}
				// this.setTimeoutID = null;
			}, this.debounceTime);
		}
	}

	protected _handleDebounce() {
		if (this._debounceTime > 0 && this._onDebounce) {
			if (this.setTimeoutID) {
				clearTimeout(this.setTimeoutID);
			}
			this.setTimeoutID = setTimeout(() => {
				if (this._onDebounce) {
					this._onDebounce();
				}
				this.setTimeoutID = null;
			}, this._debounceTime);
		}
	}

	protected _debounceTime: number = 0;

	get debounceTime() {
		return this._debounceTime;
	}

	set debounceTime(value: number) {
		this._debounceTime = value;
	}

	protected _onDebounce!: () => void;

	setTimeoutID: NodeJS.Timeout | null = null;

	/**
	 *
	 * @param time Deve ser em ms
	 */
	public setDebounceTime = (time: number, cb: () => void) => {
		this._debounceTime = time;
		if (this._debounceTime > 0) {
			// this._inputValue = "";
			this._onDebounce = cb;
			this._handleDebounce();
		}

		if (this.setTimeoutID) {
			clearTimeout(this.setTimeoutID);
		}
	};
}

export class R3InputNumberClass extends R3InputBase<number | null> {

	private _showValue: Ref<string | undefined> = ref(undefined);
	constructor(initialValue: number | null = null, name: string = '') {
		super(initialValue);
		this.name = name;
	}

	/**
	 * Foca no input do ref correspondente (PrimeVue InputNumber: input interno).
	 */
	override async setFocus(): Promise<void> {
		const el = this.elemento.value as
			| HTMLElement
			| { $el?: HTMLElement; focus?: () => void }
			| null;

		if (el == null) {
			throw new Error("Element not defined");
		}

		// Componente Vue (PrimeVue): foca o <input> interno
		const root = (el as { $el?: HTMLElement }).$el ?? (el as HTMLElement);
		if (root && typeof (root as HTMLElement).querySelector === "function") {
			const input = (
				root.tagName === "INPUT"
					? root
					: root.querySelector("input")
			) as HTMLInputElement | null;
			if (input) {
				input.disabled = false;
				input.focus();
				try {
					input.select();
				}
				catch {
					/* ignore */
				}
				return;
			}
		}

		// Fallback: foco direto no elemento/componente
		if (typeof (el as { focus?: () => void }).focus === "function") {
			(el as { focus: () => void }).focus();
		}
	}

	/**
	 * Valor exibido atrelado ao input, usado para mostrar descrições ou textos amigáveis
	 */
	public get showValue(): string | undefined {
		return this._showValue.value;
	}

	public set showValue(value: string | undefined) {
		this._showValue.value = value;
	}
}




export class R3InputTextClass<T = never> extends R3InputBase<DefaultToText<T>> {
	private _showValue: Ref<string | undefined> = ref(undefined);

	constructor(initialValue: DefaultToText<T> = undefined as DefaultToText<T>) {
		super(initialValue);
	}

	/**
	 * Valor exibido atrelado ao input, usado para mostrar descrições ou textos amigáveis
	 */
	public get showValue(): string | undefined {
		return this._showValue.value;
	}

	public set showValue(value: string | undefined) {
		this._showValue.value = value;
	}
}
